import React, { useEffect, useState } from "react";
import { BiSolidVideoPlus } from "react-icons/bi";
import digiSteth from "../../../Assets/Images/digiStethnew.png";
import digiStethCard from "../../../Assets/Images/digistethCard.png";
import digistethLungs from "../../../Assets/Images/digistethLungs.png";
import ConsultationService from "../../../Services/ConsultationService";
import { message, Select } from "antd";
import dayjs from "dayjs";

const DigitalSteth = (props) => {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [tab, setTab] = useState("Live");
  const [stethReportList, setStethReportList] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [filteredStethList, setFilteredStethList] = useState([]);

  const getStethReport = async () => {
    let payload = { patientId: props.patientDetails?.patientId, status: 1 };

    try {
      let result = await ConsultationService.getStethReport(payload);
      if (result?.data) {
        setStethReportList(result.data);
        setFilteredStethList(result.data);
      }
    } catch (error) {
      console.error("Error fetching steth report", error);
    }
  };

  useEffect(() => {
    getStethReport();
  }, []);

  const handleDateSelect = (value) => {
    setSelectedDate(value);

    if (!value) {
      setFilteredStethList(stethReportList);
      return;
    }

    const filtered = stethReportList.filter(
      (item) => item.createdDate === value
    );

    setFilteredStethList(filtered);
  };

  const convertFileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    });

  const saveUploadedFile = async () => {
    if (!selectedFile) {
      message.error("Please upload a PDF file");
      return;
    }

    try {
      const base64File = await convertFileToBase64(selectedFile);
      const payload = {
        consultationId: props.appointmentDetails?.consultationId,
        createdBy: props?.appointmentDetails?.userId,
        createdDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        document: base64File,
        documentType: "pdf",
        modifiedBy: props.appointmentDetails?.userId,
        modifiedDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        ogDocumentName: selectedFile.name,
        ogDocumentType: "DIGITAL_STETHOSCOPE",
        patientId: props.patientDetails?.patientId,
        status: 1,
        userId: props.appointmentDetails?.userId,
        appointmentId: props.appointmentDetails?.appointmentId,
      };

      let res = await ConsultationService.saveSteth(payload);

      if (res.status === 200) {
        message.success("File uploaded successfully!");
        setUploadModalOpen(false);
        setSelectedFile(null);
        getStethReport();
      }
    } catch (err) {
      console.error("Upload error:", err);
      message.error("Upload failed");
    }
  };

  // Open PDF in new tab
  const openPDF = (item) => {
    if (!item?.documentName) return;
    const finalUrl = process.env.REACT_APP_IMAGE_URL + item?.documentName;
    window.open(finalUrl, "_blank");
  };


  return (
    <div className="bg-[#F5F9FA] rounded-lg p-4 max-w-5xl mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
        <div className="flex gap-2 my-2 cursor-pointer">
          <span
            onClick={() => setTab("Live")}
            className="flex gap-2 rounded-full px-2 bg-[#FFD9D9] justify-center items-center"
          >
            <BiSolidVideoPlus className="text-[#FF4949] w-6 h-6" />
            <span>Saved Graphs</span>
          </span>
        </div>
        <Select
          style={{ width: 180 }}
          value={selectedDate}
          onChange={handleDateSelect}
          placeholder="Select Date"
          allowClear
        >
          {stethReportList.map((item) => (
            <Select.Option key={item.id} value={item.createdDate}>
              {dayjs.utc(item?.createdDate).local().format("DD/MM/YYYY HH:mm")}
            </Select.Option>
          ))}
        </Select>

        <button
          className="px-3 py-2 bg-brand-primaryColor text-white rounded"
          onClick={() => setUploadModalOpen(true)}
        >
          Upload
        </button>
      </div>

      <div>
        <div className="mt-5 max-h-[200px] overflow-y-auto pr-2">
          <h2 className="text-lg font-semibold mb-1">Saved Steth Graphs</h2>

          {filteredStethList.length === 0 && (
            <p className="text-gray-500">No saved graphs found.</p>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {filteredStethList.map((item, idx) => {
              const isPDF = item.documentName.endsWith(".pdf");

              return (
                <div
                  key={item.idx}
                  className="bg-white rounded-lg shadow p-4 border cursor-pointer hover:shadow-md transition"
                  onClick={() => isPDF && openPDF(item)}
                  title="click to view"
                >
                  <p className="font-medium truncate">Stethscope reading</p>
                  <p className="font-medium truncate">
                    {dayjs
                      .utc(item?.createdDate)
                      .local()
                      .format("YYYY-MM-DD HH:mm:ss")}
                  </p>

                  <button
                    className=" px-3 py-1 bg-brand-primaryColor text-white text-sm rounded"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (isPDF) openPDF(item);
                    }}
                  >
                    {isPDF ? "View" : "View"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {uploadModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white w-[400px] p-5 rounded shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Upload PDF</h2>

            <div className="mb-4">
              <label className="w-full cursor-pointer">
                <div className="px-4 py-2 bg-brand-primaryColor text-white rounded text-center hover:bg-brand-primaryColor transition">
                  {selectedFile ? "Change File" : "Choose File"}
                </div>

                <input
                  type="file"
                  accept="application/pdf"
                  className="hidden"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
              </label>

              {selectedFile && (
                <p className="mt-2 text-sm text-gray-600 truncate">
                  Selected:{" "}
                  <span className="font-semibold">{selectedFile.name}</span>
                </p>
              )}
            </div>

            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-300 rounded"
                onClick={() => {
                  setSelectedFile(null);
                  setUploadModalOpen(false);
                }}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 bg-brand-primaryColor text-white rounded"
                onClick={saveUploadedFile}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DigitalSteth;
